import { render, staticRenderFns } from "./RBadge.vue?vue&type=template&id=cda10598&scoped=true&"
import script from "./RBadge.vue?vue&type=script&lang=js&"
export * from "./RBadge.vue?vue&type=script&lang=js&"
import style0 from "./RBadge.vue?vue&type=style&index=0&id=cda10598&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda10598",
  null
  
)

export default component.exports